import { NotFound } from '~/shared/ui/NotFound'

export const NoAccess = () => (
  <NotFound message='У вас нет доступа к этой странице' />
)
